<template>
  <div class="solvit-dialog-form-header">
    <!--
      v-toolbar는 Vuetify 2에서 루트·.v-toolbar__content에 고정 height(64px 등) 인라인 스타일을 넣어
      두 줄 제목·긴 문구가 툴바 박스 밖으로 삐져나온다. 카드 헤더는 일반 flex 블록으로만 구성한다.
    -->
    <div class="solvit-dialog-form-header__row px-3 pt-2 pb-1">
      <div class="solvit-dialog-form-header__lead">
        <span class="solvit-dialog-form-header__kicker text-body-2 font-weight-medium text--secondary mb-0 d-block">{{ kicker }}</span>
        <span class="solvit-dialog-form-header__title text-subtitle-1 font-weight-bold text--primary">{{ title }}</span>
      </div>
      <div class="solvit-dialog-form-header__append">
        <slot name="append" />
        <v-btn
          v-if="showClose"
          icon
          small
          class="solvit-dialog-form-header__close"
          :aria-label="$t('common.close')"
          @click="$emit('close')"
        >
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </div>
    </div>
    <v-divider />
  </div>
</template>

<script>
export default {
  name: 'CrudFormDialogHeader',
  props: {
    kicker: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    closeIcon: {
      type: String,
      default: 'mdi-close'
    }
  }
};
</script>
